import ContentLoader from 'react-content-loader';

const SkeletonLoader = (props: any) => (
  <ContentLoader
    speed={2}
    width={400}
    height={240}
    backgroundColor='#f3f3f3'
    foregroundColor='#ecebeb'
    {...props}
  >
    <rect x='0' y='30' rx='0' ry='0' width='191' height='24' />
    <rect x='0' y='70' rx='0' ry='0' width='266' height='50' />
    <rect x='0' y='130' rx='0' ry='0' width='191' height='50' />
    <rect x='0' y='190' rx='0' ry='0' width='244' height='50' />
  </ContentLoader>
);

export default SkeletonLoader;
